import { MouseEventHandler } from 'react'
import classNames from 'classnames'
import { Button } from '@lounge-fe/ui-kit'
import { useSearchParams } from '@/hooks/useSearchParams'
import { LoadButtonProps } from './types'

export const LoadButton = ({
  fetch,
  isFetching = false,
  page,
  children,
  className,
  ...props
}: LoadButtonProps) => {
  const { searchParams, replace } = useSearchParams()

  const newParams = new URLSearchParams(searchParams)
  newParams.set('page', page.toString())
  const pageURL = `${window.location.pathname}?${newParams}`

  const onClick: MouseEventHandler = (evt: React.MouseEvent) => {
    evt.preventDefault()
    evt.stopPropagation()
    replace({ page: page })
    fetch()
  }

  return (
    <Button
      as="a"
      href={pageURL}
      disabled={isFetching}
      onClick={onClick}
      isLoading={isFetching}
      className={classNames('min-w-[200px]', className)}
      {...props}
    >
      {children}
    </Button>
  )
}
